const clothingPrintLocations = [
	'sleeveLeft',
	'sleeveRight',
	'shoulderLeft',
	'shoulderRight',
	'front',
	'chest',
	'chestLeft',
	'chestRight',
	'back',
	'backTop',
	'backBottom',
] as const;

export type ClothingPrintLocation = (typeof clothingPrintLocations)[number];

export function isClothingPrintLocation(arg: string): arg is ClothingPrintLocation {
	return clothingPrintLocations.some((location) => location == arg);
}

export const clothingPrintLocationDescriptions: Record<ClothingPrintLocation, string> = {
	sleeveLeft: 'Erme, venstre',
	sleeveRight: 'Erme, høyre',
	shoulderLeft: 'Skulder, venstre',
	shoulderRight: 'Skulder, høyre',
	front: 'Front (hele)',
	chest: 'Bryst',
	chestLeft: 'Bryst, venstre',
	chestRight: 'Bryst, høyre',
	back: 'Rygg (hele)',
	backTop: 'Rygg, øverst',
	backBottom: 'Rygg, nederst',
} as const;

export function isClothingPrintLocationInConflict(
	location: ClothingPrintLocation,
	others: ClothingPrintLocation[],
) {
	return (
		others.includes(location) ||
		others.some((other) => clothingPrintLocationConflicts[location].includes(other))
	);
}

export const clothingPrintLocationPreferred: ClothingPrintLocation[][] = [
	['front'],
	['chest'],
	['chestLeft'],
	['chestRight'],
	['shoulderLeft'],
	['shoulderRight'],
	['sleeveLeft'],
	['sleeveRight'],
	['front', 'shoulderLeft'],
	['front', 'shoulderRight'],
	['front', 'sleeveLeft'],
	['front', 'sleeveRight'],
	['chest', 'shoulderLeft'],
	['chest', 'shoulderRight'],
	['chest', 'sleeveLeft'],
	['chest', 'sleeveRight'],
];

export const clothingPrintLocationConflicts: Record<
	ClothingPrintLocation,
	ClothingPrintLocation[]
> = {
	sleeveLeft: [],
	sleeveRight: [],
	shoulderLeft: [],
	shoulderRight: [],
	chest: ['chestLeft', 'chestRight', 'front'],
	chestLeft: ['chest', 'front'],
	chestRight: ['chest', 'front'],
	front: ['chest', 'chestLeft', 'chestRight'],
	back: ['backTop', 'backBottom'],
	backTop: ['back'],
	backBottom: ['back'],
} as const;
